

























import mixins from 'vue-typed-mixins'
import Cta from '@/builder/sections/section/cta/mixins/Cta'

export default mixins(Cta).extend({
  name: 'Cta3'
})
